import formatters from '../../../lib/formatters'

export default {
  formatters,
  templify: formatters.templify
}
